export default "__VITE_ASSET__5757d63a__"